import React, { useState } from 'react';
import { 
  ChevronLeft, ChevronRight, Droplets, BookOpen, Users, Sun, 
  ChevronDown, ChevronUp, User, UserCheck
} from 'lucide-react';
import masailData from '../data/masail.json';

const MasailAhkam = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [gender, setGender] = useState('mard'); // 'mard' or 'aurat'
  const [expandedTopic, setExpandedTopic] = useState(null);

  // Icon Mapping (Icons resized by 40% for compact look: 28 -> 20)
  const getIcon = (iconName) => {
    const icons = {
      Droplets: <Droplets size={20} />,
      BookOpen: <BookOpen size={20} />,
      Users: <Users size={20} />,
      Sun: <Sun size={20} />
    };
    return icons[iconName] || <BookOpen size={20} />;
  };

  // Render Category List (Home View of Masail Tab)
  if (!selectedCategory) {
    return (
      <div className="list-container animate-fade-in" style={{ paddingBottom: '60px' }}>
         <div className="hero-section-premium" style={{textAlign: 'center', marginBottom: '10px', paddingTop: '10px'}}>
            <h1 className="header-main-title" style={{fontSize: '1.2rem', color: 'var(--gold-shiny)', margin: '0 0 5px 0'}}>مسائل و احکام</h1>
            <p style={{color: 'var(--text-secondary)', letterSpacing: '0.5px', fontSize: '0.65rem', fontFamily: "'Noto Nastaliq Urdu', serif", margin: 0}}>دین سیکھیں، زندگی سنواریں</p>
         </div>
         
         <div style={{padding: '0 10px', display: 'grid', gap: '8px'}}>
            {masailData.map(cat => (
               <div 
                 key={cat.id} 
                 onClick={() => setSelectedCategory(cat)}
                 className="premium-dua-card" 
                 style={{cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '10px 12px', gap: '10px', marginBottom: '4px', borderRadius: '8px'}}
               >
                  <div style={{
                    background: 'rgba(212, 175, 55, 0.1)', 
                    padding: '8px', 
                    borderRadius: '8px', 
                    color: 'var(--gold-primary)'
                  }}>
                    {getIcon(cat.icon)}
                  </div>
                  <div style={{flex: 1, textAlign: 'right'}}>
                    <h3 style={{
                      fontFamily: "'Noto Nastaliq Urdu', serif", 
                      fontSize: '0.9rem', 
                      color: 'var(--gold-shiny)',
                      margin: '0 0 3px 0'
                    }}>
                      {cat.categoryTitle}
                    </h3>
                    <p style={{
                      fontFamily: "'Noto Nastaliq Urdu', serif", 
                      fontSize: '0.7rem', 
                      color: 'var(--text-muted)',
                      margin: 0,
                      lineHeight: '1.4'
                    }}>
                      {cat.description}
                    </p>
                  </div>
                  <ChevronLeft className="gold-icon" size={16} />
               </div>
            ))}
         </div>
      </div>
    );
  }

  // Render Detail View (Specific Category Topics)
  return (
    <div className="list-container animate-fade-in" style={{ paddingBottom: '60px' }}>
       {/* Header with Back & Title (Reduced padding and font size) */}
       <div className="hero-section-premium" style={{
         display: 'flex', 
         alignItems: 'center', 
         justifyContent: 'space-between',
         padding: '10px 15px',
         marginBottom: '10px'
       }}>
          <button onClick={() => setSelectedCategory(null)} className="icon-btn-gold" style={{padding: '4px'}}>
            <ChevronRight size={20} />
          </button>
          <h2 style={{
            fontFamily: "'Noto Nastaliq Urdu', serif", 
            fontSize: '1rem', 
            color: 'var(--gold-shiny)', 
            margin: 0
          }}>
            {selectedCategory.categoryTitle}
          </h2>
          <div style={{width: 30}}></div> {/* Spacer for center alignment */}
       </div>

       {/* Gender Toggle Switch (40% Compact) */}
       <div style={{padding: '0 12px 15px 12px'}}>
         <div style={{
           display: 'flex', 
           background: 'var(--bg-card)', 
           border: '1px solid var(--gold-dim)', 
           borderRadius: '8px', 
           padding: '3px',
           position: 'relative'
         }}>
           <button 
             onClick={() => setGender('mard')}
             style={{
               flex: 1,
               padding: '6px',
               borderRadius: '6px',
               border: 'none',
               background: gender === 'mard' ? 'linear-gradient(135deg, var(--gold-primary), var(--gold-dim))' : 'transparent',
               color: gender === 'mard' ? '#000' : 'var(--text-secondary)',
               fontFamily: "'Noto Nastaliq Urdu', serif",
               fontSize: '0.8rem',
               fontWeight: 'bold',
               cursor: 'pointer',
               transition: 'all 0.3s ease',
               display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
             }}
           >
             <UserCheck size={14} /> مرد (Men)
           </button>
           <button 
             onClick={() => setGender('aurat')}
             style={{
               flex: 1,
               padding: '6px',
               borderRadius: '6px',
               border: 'none',
               background: gender === 'aurat' ? 'linear-gradient(135deg, var(--gold-primary), var(--gold-dim))' : 'transparent',
               color: gender === 'aurat' ? '#000' : 'var(--text-secondary)',
               fontFamily: "'Noto Nastaliq Urdu', serif",
               fontSize: '0.8rem',
               fontWeight: 'bold',
               cursor: 'pointer',
               transition: 'all 0.3s ease',
               display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
             }}
           >
             <User size={14} /> عورت (Women)
           </button>
         </div>
       </div>

       {/* Topics Accordion List (40% Compact) */}
       <div style={{padding: '0 12px'}}>
          {selectedCategory.topics.map((topic, index) => {
            const isOpen = expandedTopic === topic.id;
            const contentList = topic.content[gender] || ["فی الحال مواد دستیاب نہیں ہے۔"];

            return (
               <div key={topic.id} className="premium-dua-card" style={{marginBottom: '8px', borderRadius: '8px'}}>
                  <div 
                    className="dua-card-title-box" 
                    onClick={() => setExpandedTopic(isOpen ? null : topic.id)}
                    style={{
                      cursor: 'pointer', 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      background: isOpen ? 'rgba(212, 175, 55, 0.1)' : 'transparent',
                      padding: '8px 10px',
                      borderBottom: isOpen ? '1px dashed var(--glass-border)' : 'none'
                    }}
                  >
                     <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        {isOpen ? <ChevronUp className="gold-icon" size={16} /> : <ChevronDown className="gold-icon" size={16} />}
                     </div>
                     <h3 className="dua-card-title-urdu" style={{fontSize: '0.85rem', margin: 0}}>
                       {topic.title}
                     </h3>
                  </div>
                  
                  {isOpen && (
                     <div className="dua-card-body-premium animate-fade-in" style={{padding: '8px 10px'}}>
                        <ul style={{
                          listStyleType: 'none', 
                          padding: 0, 
                          margin: 0, 
                          textAlign: 'right'
                        }}>
                          {contentList.map((item, idx) => (
                            <li key={idx} style={{
                              marginBottom: '8px',
                              fontFamily: "'Noto Nastaliq Urdu', serif",
                              fontSize: '0.75rem', /* Reduced from 1.1rem */
                              color: 'var(--text-primary)',
                              lineHeight: '1.8', /* Reduced from 2.2 */
                              position: 'relative',
                              paddingRight: '15px'
                            }}>
                              <span style={{
                                position: 'absolute', 
                                right: 0, 
                                top: '8px', /* Adjusted for smaller text */
                                width: '4px', /* Smaller bullet */
                                height: '4px', 
                                background: 'var(--gold-primary)', 
                                borderRadius: '50%'
                              }}></span>
                              {item}
                            </li>
                          ))}
                        </ul>
                     </div>
                  )}
               </div>
            );
          })}
       </div>
    </div>
  );
};

export default MasailAhkam;